import { CommonService } from '@services/common.service';
import { UserService } from '@services/user.service';
import { ErrorResponse } from '@models/error.response';
import { User } from '@models/user';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { MainComponent } from './../main/main.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '@services/role.service';
import { Component, ViewChild, Input, AfterViewInit } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2'
import { switchMap } from 'rxjs/operators';

export type ChangePasswordType = 'SELF' | 'RESET';

declare var jQuery: any;

@Component({
    selector: 'user-change-password',
    templateUrl: './user-change-password.component.html',
    styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements AfterViewInit {

    @ViewChild('modal', { static: false }) modal: ModalDirective;
    @ViewChild('form', { static: false }) form: NgForm;

    @Input() targetUser: User;
    @Input() changePasswordType: ChangePasswordType = 'SELF';
    @Input() forceChangePassword: boolean = false;

    isFieldError = FormValidationUtil.isFieldError;
    loading: boolean = false;

    formData: {
        originalPassword: string;
        password: string;
        confirmPassword: string;
    }

    constructor(
        private roleService: RoleService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        public appConstant: AppConstant,
        public userService: UserService,
        private commonService: CommonService) {
    }


    ngOnInit(): void {

        this.loading = false;

        this.formData = {
            originalPassword: '',
            password: '',
            confirmPassword: ''
        }

        if (this.form != null) {
            for (let key of Object.keys(this.form.controls)) {
                this.form.controls[key].markAsPristine();
            }
        }

    }

    ngAfterViewInit(): void {
        var currentUser = this.commonService.getCurrentUser();
        if (currentUser && currentUser.isForceChangePassword) {
            this.open();
        }
    }

    public open(): void {
        this.ngOnInit();
        this.modal.show();
        // if(this.forceChangePassword){
        //     jQuery('#myModal').modal({backdrop: 'static', keyboard: false});
        // }
        // jQuery('#myModal').modal('show');
    }

    public close(): void {
        this.modal.hide();
        // jQuery('#myModal').modal('hide');
    }


    save() {

        //check form for just clicking save without any input
        for (let key of Object.keys(this.form.controls)) {
            this.form.controls[key].markAsDirty();
        }

        if (this.form.valid && this.isConfirmPasswordMatch()
            && !this.isContainUsername(this.formData.password)
            && !this.isContainUsername(this.formData.confirmPassword)
            && !this.isInvalidPasswordComplexity(this.formData.password)
            && !this.isInvalidPasswordComplexity(this.formData.confirmPassword)) {

            let instance = this;

            this.loading = true;
            this.mainComponent.enableLoadingMask();

            this.translate.get('PASSWORD')
                .pipe(
                    switchMap((passwordTranslated: string) => {
                        return this.translate.get(['UPDATE_SUCCESS',
                            'HAS_BEEN_UPDATED',
                            'UPDATE_FAIL',
                            'FAIL_TO_UPDATE'],
                            { type: passwordTranslated })
                    })
                )
                .subscribe(res => {

                    if (this.changePasswordType == 'SELF') {

                        this.userService.modifyPassword(this.formData.originalPassword, this.formData.password)
                            .subscribe(response => {
                                var currentUser = this.commonService.getCurrentUser();
                                var fc = currentUser && currentUser.isForceChangePassword;
                                this.doUpdatePasswordSuccess(res, instance);
                                if(fc){
                                    this.router.navigate(['./login']);
                                }
                            }, (error: ErrorResponse) => {
                                this.doUpdatePasswordFail(res, error, instance);
                            });

                    } else {

                        this.userService.resetPassword(this.targetUser, this.formData.password)
                            .subscribe(response => {
                                this.doUpdatePasswordSuccess(res, instance);
                            }, (error: ErrorResponse) => {
                                this.doUpdatePasswordFail(res, error, instance);
                            });

                    }

                });

        }

    }

    doUpdatePasswordSuccess(res, instance): void {
        this.mainComponent.disableLoadingMask();
        this.doResetSessionUserIsForceChangePasswordStatus(this.targetUser);
        swal.fire({
            title: res.UPDATE_SUCCESS,
            text: res.HAS_BEEN_UPDATED,
            type: "success",
            allowEscapeKey: false,
            allowOutsideClick: false,
        }).then(function () {
            instance.loading = false;
            this.authService.logout();
            this.router.navigate(['']);
            instance.close();
        }).catch(() => {
            instance.loading = false;
            instance.close();
        });
    }


    doUpdatePasswordFail(res, error: ErrorResponse, instance): void {
        this.mainComponent.disableLoadingMask();

        instance.translate.get(error.errors[0].errorCode).subscribe(errorMsg => {
            swal.fire({
                title: res.UPDATE_FAIL,
                text: errorMsg,
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then(function () {
                instance.loading = false;
                // do nothing
            }).catch(() => {
                instance.loading = false;
            });
        });
    }

    doResetSessionUserIsForceChangePasswordStatus(user: User): void {
        if (this.forceChangePassword && user) {
            user.isForceChangePassword = false;
            this.commonService.setCurrentUser(user);
        }
    }

    isConfirmPasswordMatch(): boolean {
        if (this.formData != null
            && this.formData.confirmPassword != null && this.formData.confirmPassword !== ''
            && this.formData.password != null && this.formData.password !== '') {
            if (this.formData.confirmPassword !== this.formData.password) {
                return false;
            }
        }
        return true;
    }

    isContainUsername(value): boolean {

        if (this.targetUser == null) {
            return false;
        }

        if (!value) {
            return false;
        }

        if (value.toLowerCase().indexOf(this.targetUser.username.toLowerCase()) !== -1) {
            return true;
        } else {
            return false;
        }

    }

    isInvalidPasswordComplexity(value): boolean {

        if (value == null || value.trim() == '') {
            return false;
        }

        return !(new RegExp(this.appConstant.passwordComplexityRegex).test(value));
    }

}